import React, { useEffect, useState, useContext } from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';

function InverterList({rows}) {
    const { t } = useTranslation();

    return (
        <div with="100%" height="100%" style={{padding: "0", overflowX: "auto"}}>
            <Table 
                pagination={false}
                dataSource={rows} 
                scroll={{ x: 'max-content' }}
                columns={[{
                    title: t("Inverter SN"),
                    dataIndex: "SN",
                    render: (v,r) => {
                        return `${v}${r.Phase == 2 ? "(A)" : r.Phase == 3 ? "(B)" : r.Phase == 4 ? "(C)" : ""}`;
                    }
                },
                { title: t("Mounted Batteries"), dataIndex: "Batteries",  align: "left",render: (v,r) => {
                    return v&&(v.map((item,index) => {return item.SN}).join(", "));
                } },
                { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" }, 
                { title: t("PPV1")+"(kW)", dataIndex: "PPV1",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""}},
                { title: t("VPV1")+"(V)", dataIndex: "VPV1",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("PPV2")+"(kW)", dataIndex: "PPV2",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""}},
                { title: t("VPV2")+"(V)", dataIndex: "VPV2",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("PPV3")+"(kW)", dataIndex: "PPV3",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""}},
                { title: t("VPV3")+"(V)", dataIndex: "VPV3",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("PPV4")+"(kW)", dataIndex: "PPV4", align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""} },
                { title: t("VPV4")+"(V)", dataIndex: "VPV4", align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("SOC")+"(%)", dataIndex: "BatteryCapacity",  align: "right"},
                { title: t("PBattery")+"(kW)", dataIndex: "PBattery",  align: "right", render: (v,r) => {
                    if (v == null) {
                        return "";
                    }
                    v = parseInt(v);
                    if (v > 0x7fffffff) {
                        v = v - 0x100000000;
                    }
                    return (v * 0.0001).toFixed(3);
                }},
                { title: t("VBattery")+"(V)", dataIndex: "VBattery",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("PAC1Load")+"(kW)", dataIndex: "PAC1Load",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""} },
                { title: t("PAC2Load")+"(kW)", dataIndex: "PAC2Load",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""} },
                { title: t("PAC3Load")+"(kW)", dataIndex: "PAC3Load",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.0001).toFixed(3):""} },
                
                { title: t("PAC1Grid")+"(kW)", dataIndex: "PAC1Grid",  align: "right", render: (v,r) => {
                    if (v == null) {
                        return "";
                    }
                    v = parseInt(v);
                    if (v > 0x7fffffff) {
                        v = v - 0x100000000;
                    }
                    return (v * 0.0001).toFixed(3);
                }},
                { title: t("VAC1Grid")+"(V)", dataIndex: "VAC1Grid",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("PAC2Grid")+"(kW)", dataIndex: "PAC2Grid", align: "right", render: (v,r) => {
                    if (v == null) {
                        return "";
                    }
                    v = parseInt(v);
                    if (v > 0x7fffffff) {
                        v = v - 0x100000000;
                    }
                    return (v * 0.0001).toFixed(3);
                }},
                { title: t("VAC2Grid")+"(V)", dataIndex: "VAC2Grid", align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("PAC3Grid")+"(kW)", dataIndex: "PAC3Grid", align: "right", render: (v,r) => {
                    if (v == null) {
                        return "";
                    }
                    v = parseInt(v);
                    if (v > 0x7fffffff) {
                        v = v - 0x100000000;
                    }
                    return (v * 0.0001).toFixed(3);
                }},
                { title: t("VAC3Grid")+"(V)", dataIndex: "VAC3Grid", align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.1).toFixed(1):""} },
                { title: t("GridHz")+"(Hz)", dataIndex: "GridHz",  align: "right", render: (v,r) => {return v!=null?(parseFloat(v)*0.01).toFixed(1):""} },
                ]}  
            />
        </div>
    );
}

export default InverterList;